import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

import * as socketIo from 'socket.io-client';

import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

const SERVER_URL = environment.SERVER_CHAT;

@Injectable()
export class ChatService extends ApiEvsService {
  private socket;

  constructor(
    http: Http,
    router: Router,
    private toastr: ToastrService
  ) {
    super(http, router);
  }
  public initSocket(tenant_id, agent_id, role, username, userId): void {
    this.socket = socketIo(SERVER_URL, {
      transports: ['websocket'],
      query: {
        tenant_id: tenant_id,
        agent_id: agent_id,
        is_agent: 1,
        role: role,
        username: username,
        user_id: userId,
      },
    });
    this.socket.on(
      'connect',
      function () {
        console.log('Client has connected to the chatserver! socket_id ' + this.socket.id);
      }.bind(this)
    );
    this.socket.on('disconnect', function () {
      console.log('The client has disconnected from the chatserver!');
    });
  }
  public closeSocket() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  public send(ticket_id, message: any) {
    this.socket.emit('newMessage', ticket_id, message);
  }

  public sendInternal(room_id, message: any) {
    this.socket.emit('newMessageInternal', room_id, message);
  }

  public onMessage(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('addMessage', (data: any) => observer.next(data));
    });
  }

  public onMessageInternal(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('addMessageInternal', (data: any) => observer.next(data));
    });
  }

  public onRefreshContact(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('refresh-contact', (data: any) => observer.next(data));
    });
  }

  public onRefreshStatus(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('refresh-status', (data: any) => observer.next(data));
    });
  }

  public onUpdateChatting(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('update-chatting', (data: any) => {
        observer.next(data);
      });
    });
  }
  public onUpdateChattingInternal(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('updateChattingInternal', (data: any) => observer.next(data));
    });
  }

  public inviteChat(agent_id, from_user_id, from_user, tenant_id, ticket_id, status) {
    this.socket.emit('invite', agent_id, from_user_id, from_user, tenant_id, ticket_id, status);
  }

  public onInviteChat(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('invite', (data: any) => observer.next(data));
    });
  }

  public forwardChat(data?: any) {
    this.socket.emit('forward', data);
  }

  public onForwardChat(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('forward', (data: any) => observer.next(data));
    });
  }

  public onContactRequestChat(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('contact-request-chat', (data: any) => observer.next(data));
    });
  }

  public onEvent(event: any): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on(event, () => observer.next());
    });
  }

  public onUpdateMonitor(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('update-monitor', (data: any) => observer.next(data));
    });
  }

  public onUpdateWebhook(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('update-web-hook', (data: any) => observer.next(data));
    });
  }

  public join(data: any): void {
    this.socket.emit('join', data);
  }

  public joinFbWebhook(room_id: any): void {
    this.socket.emit('joinFbWebhook', room_id);
  }

  public leave(room_id: any): void {
    this.socket.emit('leave', room_id);
  }

  public joinInternal(room_id, agent_id) {
    this.socket.emit('internal_join', room_id, agent_id);
  }

  public monitor(data) {
    this.socket.emit('monitor', data);
  }

  list(query?: any) {
    return this.get('/v2/new-chattings', query);
  }

  listInternal(query?: any) {
    return this.get('/internal-chats', query);
  }

  config(query?: any) {
    return this.get('/chat-config', query);
  }

  updateConfig(data: any) {
    return this.put('/chat-config', data);
  }

  history(room_id, data?: any) {
    return this.get('/v2/history/' + room_id, data);
  }

  agentOnlines(query?: any) {
    return this.get('/agent-online', query);
  }

  agentsInTicket(ticket_id, query?: any) {
    return this.get('/agents-in-ticket/' + ticket_id, query);
  }

  saveToTicket(ticket_id, body?: any) {
    return this.post('/save-to-ticket/' + ticket_id, body);
  }

  unread() {
    return this.get('/v2/unread');
  }

  internalChat(friend_id) {
    return this.post('/internal-chat/' + friend_id);
  }

  editRoomName(room_id, body) {
    return this.put('/update-name-internal/' + room_id, body);
  }

  resetUnreadInternal(room_id) {
    return this.put('/reset-unread-internal/' + room_id);
  }

  historyInternal(room_id, data?: any) {
    return this.get('/internal-history/' + room_id, data);
  }

  inviteFriendInternal(room_id, friend_id) {
    return this.put('/invite-friend-internal/' + room_id, {
      friend_id: friend_id,
    });
  }

  leaveRoomInternal(room_id) {
    return this.delete('/leave-room-internal/' + room_id);
  }
  // http ottgateway
  closeChat(body?: any) {
    return this.postFullUrl(environment.url_ottgateway + '/closechat', body);
  }
  updateSystemStatus(body?: any) {
    return this.postFullUrl(environment.url_ottgateway + '/updatesystemstatus', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Chat.service.ts